import axios from "axios";
export async function get(assessment_id: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/strategy/assessment/"+assessment_id);
    return response.data;
}

export const update = async (row:any, assessment_id: string, strategy_id?: string) => {
    let response = null;
    if(!strategy_id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/strategy/assessment/"+assessment_id+"/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/strategy/update/"+strategy_id,row);
    }
    return response.data;
};

export const approve = async (strategy_id?: string) => {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/strategy/approve/"+strategy_id);
    return response.data;
};

export const destroy = async (id:any) => {
    let response = null;
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/strategy/delete/"+id);
    return response.data;
};


export async function getControls(strategy_id: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/strategy/controls/"+strategy_id);
    return response.data;
}

export const saveTreatments = async (row:any, assessment_id:string, control_id: string) => {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/strategy/assessment/"+assessment_id+"/save-treatments/"+control_id,row);
    return response.data;
};

export const autoTreatments = async (assessment_id:string) => {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/strategy/assessment/"+assessment_id+"/auto-treatments");
    return response.data;
};